var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraserSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2610_17157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 15.9994H7.665L9.5 14.1844L4.55 9.23438L1.77 11.9994C1.68413 12.0844 1.61597 12.1857 1.56946 12.2973C1.52294 12.4088 1.49899 12.5285 1.49899 12.6494C1.49899 12.7702 1.52294 12.8899 1.56946 13.0015C1.61597 13.1131 1.68413 13.2143 1.77 13.2994L4.5 15.9994H1.5C1.36739 15.9994 1.24021 16.0521 1.14645 16.1458C1.05268 16.2396 1 16.3668 1 16.4994C1 16.632 1.05268 16.7592 1.14645 16.8529C1.24021 16.9467 1.36739 16.9994 1.5 16.9994H14C14.1326 16.9994 14.2598 16.9467 14.3536 16.8529C14.4473 16.7592 14.5 16.632 14.5 16.4994C14.5 16.3668 14.4473 16.2396 14.3536 16.1458C14.2598 16.0521 14.1326 15.9994 14 15.9994Z",
    fill: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0394 5.32726L13.3894 1.67726C13.3043 1.59139 13.2031 1.52323 13.0915 1.47672C12.9799 1.4302 12.8602 1.40625 12.7394 1.40625C12.6185 1.40625 12.4988 1.4302 12.3873 1.47672C12.2757 1.52323 12.1744 1.59139 12.0894 1.67726L5.23438 8.53226L10.1844 13.4823L17.0394 6.62726C17.2104 6.45413 17.3063 6.22059 17.3063 5.97726C17.3063 5.73392 17.2104 5.50039 17.0394 5.32726Z",
    fill: "#FF4E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2610_17157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserSolid);
export default __webpack_public_path__ + "static/media/eraser-solid.6578d9dc1f6281ebdd335ba9c51b6ad4.svg";
export { ForwardRef as ReactComponent };